import { Roles } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';
import { TaskCategories } from '@/enums/tasks';
import { Action, ApprovalApproveManager, ApprovalApproveMineManager, ApprovalApproveSuperIntendent, ValidityTypes } from '@/interfaces/approvals/approvals';
import { Person } from '@/interfaces/person';
import { Details, Flow } from '@/interfaces/requirement';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { PersonService } from '@/services/person/person.service';
import { RequirementService } from '@/services/requirement/requirement.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { normalize } from '@/utils/normalizeString';
import { deofuscate, ofuscate } from '@/utils/obfuscation';
import { mustHaveOneRecord } from '@/validators/mustHaveOneRecord';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { validityDayValidator } from './additional-info/addtition-info.validator';
import { Location } from '@angular/common';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {
  form = new FormGroup({
    documentTable: new FormArray([]),
    mineDocumentTable: new FormArray([]),
    additionalInfo: new FormGroup({
      validity: new FormControl(0),
      validityTemporaryDays: new FormControl(''),
      comentaryTemporaryDays: new FormControl(''),
      municipalLicenses: new FormControl([], [mustHaveOneRecord()]),
      restrictionDriver: new FormControl('', []),
    }, []),
  });

  get additionalInfoForm(): FormGroup {
    return this.form.controls.additionalInfo as FormGroup;
  }
  get documentTableForm(): FormArray {
    return this.form.controls.documentTable as FormArray;
  }
  get mineDocumentTableForm(): FormArray {
    return this.form.controls.mineDocumentTable as FormArray;
  }

  requirementId: number = 0;
  selectedAction: Action = '';

  dataRequirement?: Details;
  dataRequirementGetting: boolean = true;
  dataRequirementError: boolean = false;

  personData: Partial<Person> = {};
  personDataGetting: boolean = true;
  personDataError: boolean = false;

  selectedPersonIsEmployee: boolean = false;

  flowData: Flow[] = [];

  get equipments(): Details['equipments'] {
    return this.dataRequirement?.equipments || [];
  }
  get documents(): Details['documents'] {
    return this.dataRequirement?.documents || [];
  }

  requirementType: TaskCategories = TaskCategories.APROBACION;

  loggedUser?: Person;
  get loggedUserRole(): Roles {
    return this.virtualRole;
  }

  virtualRole: Roles = '';

  get shouldShowLicenseLink(): boolean {
    return this.virtualRole === 'DLMS_EMPLOYEE_CO' && this.requirementType === TaskCategories.RENOVACION;
  }

  get shouldShowAdditionalInfoForm(): boolean {
    const acceptedRoles: Roles[] = [
      'DLMS_SOL_OPE_MEL',
      'DLMS_SOL_OPE_SPC',
      'DLMS_SOL_PRO_MEL',
      'DLMS_SOL_PRO_SPC',
    ];
    return acceptedRoles.includes(this.virtualRole);
  }
  additionalInfoValidators: boolean = false;

  get shouldShowMineDocumentTable(): boolean {
    const acceptedRoles: Roles[] = [
      'DLMS_SOL_MINA_MEL',
      'DLMS_SOL_MINA_SPC',
    ];
    return acceptedRoles.includes(this.virtualRole);
  }

  get shouldActivateApproveButton(): boolean {
    if (this.shouldShowAdditionalInfoForm || this.shouldShowMineDocumentTable) {
      if (this.shouldShowMineDocumentTable) {
        return (this.form.controls.mineDocumentTable.valid && this.form.controls.documentTable.valid) && (this.form.controls.mineDocumentTable as FormArray).controls.length > 0;
      }
      return this.form.valid;
    }
    return !!this.dataRequirement;
  }

  validityTypes: ValidityTypes[] = [];

  infoAdditional: boolean = false;
  rolUser: string = '';
  assetDriver: number = 0;
  assetRequestApprover: boolean = false;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private requirementService: RequirementService,
    private personService: PersonService,
    private approvalsService: ApprovalsService,
    private store: Store<StoreState>,
    private auth: AuthService,
    private _location: Location,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (loggedUser) => {
        this.loggedUser = loggedUser;
      },
    });
  }

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      const { id, requirementTypeId } = params;

      this.requirementId = id;
      this.requirementType = requirementTypeId;

      const storeLoginSlice$ = getCurrentUserData(this.store);

      storeLoginSlice$.subscribe({
        next: (loggedUser) => {
          this.loggedUser = loggedUser;
          const myRole = this.auth.getUserRoleName();
          const myRoleId = this.auth.getMyRole().id;
          if (!(myRole === 'DLMS_OWNER_SPC' || myRole === 'DLMS_OWNER_MEL')) {
            this.approvalsService.updateAssigned(this.requirementId, this.loggedUser.mdmid, myRoleId).subscribe({
              next: () => {
              },
            });
          }
        },
      });

      this.requirementService.getFlow(id).subscribe({
        next: (flow) => {
          this.flowData = flow;
          const firstPendingFlow = this.requirementService.getFirstPendingFlowStep(flow);
          if (firstPendingFlow) {
            this.virtualRole = this.auth.getRoleNameById(firstPendingFlow.roleId) as any;
          }
        },
      });

      this.requirementService.getDetails(id).subscribe({
        next: (details) => {
          // const documents = details.documents.filter(({ isMineRequired }) => !isMineRequired);
          this.requirementType = details.requirementTypeId;
          this.dataRequirement = details;

          this.assetDriver = details.assetId;
          this.dataRequirementGetting = false;

          if (this.shouldShowAdditionalInfoForm) {
            this.approvalsService.getValidityTypes(details.assetId).subscribe({
              next: (validityTypes) => {
                this.validityTypes = validityTypes;
                if (validityTypes.length > 0) {
                  this.form.controls.additionalInfo.setValidators([validityDayValidator('validity', 'validityTemporaryDays', 1)]);
                  this.additionalInfoValidators = true;
                  this.form.controls.additionalInfo.updateValueAndValidity();
                }
              },
            });
          }

          this.onShowFormMelAdditionalInformation();
          this.personService.getPersonDataByMdmid(details.driverMdmid).subscribe({
            next: (res: Person) => {
              this.personData = res;
              this.personDataGetting = false;
              this.selectedPersonIsEmployee = normalize(this.personData?.entity) === normalize('Employee');
            },
            error: () => {
              this.personDataGetting = false;
              this.personDataError = true;
            },
          });

          // Solo este control tiene validaciones al momento de generarse
          if (!this.shouldShowAdditionalInfoForm && this.additionalInfoValidators) {
            this.additionalInfoValidators = false;
            this.form.controls.additionalInfo.clearValidators();
            this.form.controls.additionalInfo.updateValueAndValidity();
            // this.form.removeControl('additionalInfo');
          }
        },
        error: () => {
          this.dataRequirementGetting = false;
          this.dataRequirementError = true;
        },

      });
    });

  }

  selectAction(selectedAction: Action) {
    const myRoleId = this.auth.getMyRole().id;

    if (selectedAction === 'approve' && this.shouldShowAdditionalInfoForm) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres aprobar esta solicitud?',
        text: 'Si ya has revisado la información registrada y está correcta, continúa en Aprobar Solicitud.',
        text2: 'De lo contrario, ingresa a Volver para revisar la información.',
        acceptButtonText: 'Aprobar Solicitud',
        actionOnAccept: () => {
          const formData = this.form.value;
          if (this.loggedUser) {
            this.store.dispatch(loaderAnimationShow());
            const params: ApprovalApproveManager = {
              actionType: 3, // valor fijo dependiendo del tipo de accion
              licenseId: this.dataRequirement?.licenseId as number,
              requirementId: this.requirementId,
              updaterMdmid: this.loggedUser?.mdmid,
              updaterRole: this.auth.getMyRole().id,
              additionalInformation: {
                licenseValidity: formData.additionalInfo.validity,
                licenseValidityTemporaryDays: formData.additionalInfo.validityTemporaryDays,
                licenseValidityTemporaryComment: formData.additionalInfo.comentaryTemporaryDays,
                municipalLicense: formData.additionalInfo.municipalLicenses,
                driverRestrictionsComment: formData.additionalInfo.restrictionDriver,
              },
              documentRequiredDefault: formData.documentTable.map((editingDocument: any) => ({
                id: editingDocument.id,
                documentRequiredTypeId: editingDocument.documentRequiredTypeId,
                // fileName: editingDocument.fileName,
                // path: editingDocument.fileUrl,
                createdAt: editingDocument?.dateEmit,
                dateFrom: editingDocument?.dateFrom,
                dateTo: editingDocument?.dateUntil,
              })),
            };

            this.approvalsService.updateAssigned(this.requirementId, this.loggedUser.mdmid, myRoleId).pipe(
              catchError((x) => of(false)),
              mergeMap((x) => this.approvalsService.approveApprovalManager(params, this.virtualRole)),
            ).subscribe({
              next: () => {
                this.store.dispatch(loaderAnimationHide());
                const ofuscatedData = ofuscate({ email: this.personData.email });
                this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {
                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });
                    }
                  },
                });
              },
            });
          }

        },
      }));
      return;
    }

    if (selectedAction === 'approve' && this.shouldShowMineDocumentTable) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres aprobar esta solicitud?',
        text: 'Si ya has revisado la información registrada y está correcta, continúa en Aprobar Solicitud.',
        text2: 'De lo contrario, ingresa a Volver para revisar la información.',
        acceptButtonText: 'Aprobar Solicitud',
        actionOnAccept: () => {
          const formData = this.form.value;
          if (this.loggedUser) {
            this.store.dispatch(loaderAnimationShow());
            const params: ApprovalApproveMineManager = {
              actionType: 3, // valor fijo dependiendo del tipo de accion
              requirementId: this.requirementId,
              updaterRole: this.auth.getMyRole().id,
              updaterMdmid: this.loggedUser?.mdmid,
              documentRequirementMine: formData.mineDocumentTable.filter(({ isEnabled }: any) => isEnabled).map((mineDocument: any) => ({
                documentMineId: mineDocument.id,
                requirementStatus: mineDocument.documentStatusId,
                dateFrom: mineDocument.dateFrom,
                dateTo: mineDocument.dateUntil,
              })),
            };

            this.approvalsService.updateAssigned(this.requirementId, this.loggedUser.mdmid, myRoleId).pipe(
              catchError((x) => of(false)),
              mergeMap((x) => this.approvalsService.approveApprovalMineManager(params, this.virtualRole)),
            ).subscribe({
              next: () => {
                this.store.dispatch(loaderAnimationHide());
                const ofuscatedData = ofuscate({ email: this.personData.email });
                this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });

                    }
                  },
                });
              },
            });

          }
        },
      }));
      return;
    }
    if (selectedAction === 'approve' && this.virtualRole === 'DLMS_EMPLOYEE_SI') {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres aprobar esta solicitud?',
        text: 'Si ya has revisado la información registrada y está correcta, continúa en Aprobar Solicitud.',
        text2: 'De lo contrario, ingresa a Volver para revisar la información.',
        acceptButtonText: 'Aprobar Solicitud',
        actionOnAccept: () => {
          if (this.loggedUser) {
            this.store.dispatch(loaderAnimationShow());
            const params: ApprovalApproveSuperIntendent = {
              actionType: 3, // valor fijo dependiendo del tipo de accion
              requirementId: this.requirementId,
              updaterMdmid: this.loggedUser?.mdmid,
              updaterRole: this.auth.getMyRole().id,
            };

            this.approvalsService.approveApprovalSuperintendent(params, this.virtualRole).subscribe({
              next: () => {
                const ofuscatedData = ofuscate({ email: this.personData.email });
                this.store.dispatch(loaderAnimationHide());
                this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigate(['approved', ofuscatedData], { relativeTo: this.route });

                    }
                  },
                });
              },
            });
          }
        },
      }));
      return;
    }
    this.selectedAction = selectedAction;
  }

  onShowFormMelAdditionalInformation() {

    if (this.assetDriver === 1) {
      this.assetRequestApprover = true;
    }
    else {
      this.assetRequestApprover = false;
    }
  }

  onShowRequestDetail() {
    const ofuscatedData = ofuscate({ id: this.requirementId });
    this.router.navigateByUrl(`/license/show/${ofuscatedData}`);
  }
  goBack() {
    this._location.back()
  }
}
